import { Action } from '@ngrx/store';
import { GetTransactionCommentsWithdrawDto } from '../models/comment.model';
import { WithdrawCommentPayload } from '../models/withdraw-comment.model';

export enum CommentActions {
    GetComments = '[Comments] Get Comments',
    GetTransactionComments = '[Comments] Get Transaction comments',
    GetCommentsSuccess = '[Comments] Get comments success',
    GetCommentsFailure = '[Comments] Get Comments Failure',
    GetTransactionCommentsWithdraw = '[Comments] Get Transaction Comments Withdraw',
    GetWithdrawCommentsSuccess = '[Comments] Get withdraw comments success ',
    GetWithdrawCommentsFailure = '[Comments] Get withdraw Comments Failure',
}

export class getComments implements Action {
    readonly type = CommentActions.GetComments;
}

export class GetTransactionComments implements Action {
    readonly type = CommentActions.GetTransactionComments;
    constructor(public payload: any) {}
}

export class GetCommentsSuccess implements Action {
    readonly type = CommentActions.GetCommentsSuccess;
    constructor(public payload: any) {}
}
export class GetCommentsFailure implements Action {
    readonly type = CommentActions.GetCommentsFailure;
    constructor(public payload: any) {}
}

export class GetTransactionCommentsWithdraw implements Action {
    type = CommentActions.GetTransactionCommentsWithdraw;
    constructor(public payload: GetTransactionCommentsWithdrawDto) {}
}

export class GetWithdrawCommentsSuccess implements Action {
    readonly type = CommentActions.GetWithdrawCommentsSuccess;
    constructor(public payload: WithdrawCommentPayload) {}
}

export type CommentAction =
    | getComments
    | GetTransactionComments
    | GetCommentsSuccess
    | GetCommentsFailure
    | GetTransactionCommentsWithdraw
    | GetWithdrawCommentsSuccess;
